import types from './userTypes'
import { actionCreator } from '../actionCreator'

export default {
  ...actionCreator({
    addUser: types.ADD_USER,
    addUserSuccess: types.ADD_USER_SUCCESS,
    addUserFailure: types.ADD_USER_FAILURE,
    setRememberMe: types.SET_REMEMBER_ME
  })
}
